import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 9,
    fontFamily: "Helvetica",
    paddingBottom: 40,
  },
  header: {
    alignItems: "center",
    marginBottom: 10,
    position: "relative",
  },
  bottomLogo:{
    position: "absolute",
    bottom: 20,          
    left: 0,
    right: 0,            
    alignItems: "center",
    textAlign: "center",
  },
  logo: {
    width: "70px",
    height: "auto",
    alignSelf: "center",
  },
  
  reportTitle: {
    fontSize: 16,
    color: "#000",
    marginBottom: 3,
  },
  reportPeriod: {
    fontSize: 14,
    color: "#000",
    marginBottom: 3,
  },
  texasLogoRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  texasLogo: {
    width: "100px",
  },
  formNumber: {
    fontSize: 8,
    color: "#000",
  },
  sectionTitle: {
    fontSize: 10,
    marginBottom: 5,
    textAlign: "center",
    color: "#000",
  },
  infoRow: {
    flexDirection: "row",
    borderTop: "1px solid #000",
    borderBottom: "1px solid #000",
    borderLeft: "1px solid #000",
    borderRight: "1px solid #000",
  },
  infoCell: {
    padding: 4,
    width: "35%",
    borderRight: "1px solid #000",
    fontSize: 8,
  },
  label: {
    fontWeight: "bold",
    fontSize: 7,
  },
  table: {
    marginTop: 5,
    border: "1px solid #000",
  },
  tableRowDays: {
    flexDirection: "row",
    // borderBottom: "1px solid #000",
  },
   tableRow: {
    flexDirection: "row",
    borderBottom: "1px solid #000",
  },
  tableHeader: {
    fontWeight: "bold",
    fontSize: 8,
  },
  tableCell: {
    padding: 4,
    borderRight: "1px solid #000",
    fontSize: 7,
    minHeight: 20,
  },
  dayColumn: {
    width: "18%",
    textAlign: "center",
  },
  skillColumn: {
    width: "28%",
  },
  timeCell: {
    width: "50%",
    minHeight: 20,
  },
  providerCell: {
    width: "100%",
  },
  signatureCell: {
    minHeight: 15,
  },
  boldText: {
    fontWeight: "bold",
  },
  // Page 2 Styles
  skillTable: {
    marginTop: 7,
  },
  skillRow: {
    flexDirection: "row",
    borderBottom: "1px solid #000",
    minHeight: 25,
  },
  skillNameCell: {
    width: "30%",
    padding: 4,
    borderRight: "1px solid #000",
    fontSize: 8,
  },
  dayCell: {
    width: "14%",
    padding: 4,
    borderRight: "1px solid #000",
    textAlign: "center",
    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
    // fontSize: 8,  

  },
  tableCellStyle: {
    borderTop: "1px solid #000",
    padding: 4,
    fontSize: 7,
    minHeight: 20,
    // backgroundColor: "red",
  },
  sectionHeader: {
    fontWeight: "bold",
    padding: 5,
  },
  communityTable: {
    marginTop: 10,
    border: "1px solid #000",
  },
  communityRow: {
    flexDirection: "row",
    borderBottom: "1px solid #000",
    minHeight: 30,
  },
  dateCell: {
    width: "20%",
    padding: 4,
    borderRight: "1px solid #000",
  },
  staffCell: {
    width: "20%",
    padding: 4,
    borderRight: "1px solid #000",
  },
  commentsCell: {
    width: "60%",
    padding: 4,
  },
  sigText: {
    fontFamily: "Island Moments",
    fontSize: 18,
    textAlign: "center",
  },
  emptyPage: {
    padding: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  emptyContainer: {
    textAlign: 'center',
    padding: 20,
  },
  emptyTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 16,
  },
  emptyMessage: {
    fontSize: 14,
    color: '#666',
    marginBottom: 8,
  },
  emptySubMessage: {
    fontSize: 12,
    color: '#999',
  },
});
